import Vue from "@/main";

export let graphicLayer;

export function createdGraphicLayer() {
  graphicLayer = new mars3d.layer.GraphicLayer();
  if (Vue.$GLOBAL.map.addLayer) {
    Vue.$GLOBAL.map.addLayer(graphicLayer);
  } else {
    setTimeout((res) => {
      createdGraphicLayer();
    }, 1000);
  }
}

export function drawLine(arr, label, id) {
  const graphic = new mars3d.graphic.PolylineEntity({
    positions: arr,
    type: "polyline",
    style: {
      width: 5,
      clampToGround: false,
      materialType: "LineBloom",
      materialOptions: {
        color: "blue",
        opacity: 0.9,
        glow: 1,
        materialType: "LineBloom",
        speed: 5,
      },
      label: { text: label, pixelOffsetY: -30 },
      id: id,
    },
  });
  if (!graphicLayer) createdGraphicLayer();
  graphicLayer.addGraphic(graphic);
  setTimeout(() => {
    Vue.$GLOBAL.map.flyToGraphic(graphic, { radius: 2000 });
  }, 500);
}

export function deleteGraphic(id) {
  graphicLayer.eachGraphic((graphic) => {
    if (graphic?.options?.style.id == id) {
      graphicLayer.removeGraphic(graphic);
    }
  });
}
export function reset() {
  if (graphicLayer) {
    graphicLayer.clear(true);
    Vue.$GLOBAL.map.removeLayer(graphicLayer);
  }
}
